import React from "react";
import 'components/UI/InputFormComponent/InputFormComponent.scss';

const InputFormComponent = ({type, name, className, autoFocus, value, onChange, placeholder, disabled}) => {
	return (
		<input
			className={disabled ? `${className} disabled` : className}
			placeholder={placeholder}
			type={type}
			name={name}
			autoFocus={autoFocus}
			value={value}
			onChange={onChange}
			disabled={disabled}
		/>
	);
};

export default InputFormComponent;
